export class UnsucessfulFetchError extends Error {
    constructor({ message, response }) {
        super(message !== null && message !== void 0 ? message : response.statusText);
        this.name = UnsucessfulFetchError.name;
        this.response = response;
    }
    get url() {
        return this.response.url;
    }
    get status() {
        return this.response.status;
    }
}
export function isUnsucessfulFetchError(value) {
    return value.name === UnsucessfulFetchError.name;
}
//# sourceMappingURL=unsuccessful-fetch-error.js.map